<template>
  <button
    v-if="canBeSummarized"
    @click="summarize"
    title="Log activity" v-tippy><crm-logo /></button>
</template>

<script>
import CrmLogo from 'vue-components/crm-logo/crm-logo'
import store from '@/lib/store'

export default {
  components: {
    CrmLogo
  },
  props: [
    'activity'
  ],
  data () {
    return {
      user: store.get('user')
    }
  },
  computed: {
    canBeSummarized () {
      return this.activity.isSummarized === false &&
        this.activity.isInternal === false &&
        this.activityBelongsToUser
    },
    activityBelongsToUser () {
      return this.activity.organizer.id === this.user.id
    }
  },
  methods: {
    summarize () {
      this.$router.push({
        path: `/meetings/${this.activity.id}?tab=activity-summary`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// SummarizeButton.vue?32825cd6